import React, { useState } from "react";
import { Drawer, Form, Select, Button, Row, Col, Typography, Divider, Input } from "antd";
import Swal from "sweetalert2";
import { Modal } from 'react-bootstrap';
import NewWarehouse from "./NewWarehouse";


const ModifyWarehouseDrawer = ({ open, onClose, dropdown, fetchWarehouselist }) => {
    const [isEditingUser, setIsEditingUser] = useState(false);

    const [form] = Form.useForm();

    const [selectedRegion, setSelectedRegion] = useState(null);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const [EditWarehouse, setEditWarehouse] = useState(null);
    const [originalWarehouse, setOriginalWarehouse] = useState(null);
    const [inputUrl, setInputUrl] = useState('');
    const [showVideo, setShowVideo] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const { Option } = Select;
    const { Text } = Typography;

    const handleUpdateMap = () => {
        setEditWarehouse(prev => ({
            ...prev,
            map: inputUrl
        }));
    };

    const [images, setImages] = useState([
        "https://via.placeholder.com/150",
        "https://via.placeholder.com/160",
        "https://via.placeholder.com/170",
    ]); // initial images
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    // Open modal at clicked image
    const openModal = (index) => {
        setCurrentIndex(index);
        setShowModal(true);
    };
    // Navigate images in modal
    const nextImage = () => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
    };
    const prevImage = () => {
        setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
    };
    // Remove current image
    const removeImage = () => {
        const newImages = [...images];
        newImages.splice(currentIndex, 1);
        setImages(newImages);
        if (currentIndex >= newImages.length) setCurrentIndex(newImages.length - 1);
        if (newImages.length === 0) setShowModal(false);
    };
    // Add new image
    const addImage = () => {
        const url = prompt("Enter image URL");
        if (url) setImages([...images, url]);
    };

    const onsubmit = async () => {
        try {
            const formData = new FormData();
            formData.append("wh_id", selectedWarehouse);
            formData.append("region", selectedRegion);

            const response = await fetch(
                "https://ambronex.in/apis/WarehouseModification.php",
                {
                    method: "POST",
                    body: formData,
                }
            );

            const result = await response.json();

            if (
                result.status === "success" &&
                Array.isArray(result.data)
            ) {
                setEditWarehouse(result?.data[0])
                setOriginalWarehouse(result.data[0])
                form.resetFields();
            } else {
                setEditWarehouse(null);
                setOriginalWarehouse(null);
            }
        } catch (err) {
            console.error("Fetch Error:", err);
            setOriginalWarehouse(null);
            setEditWarehouse(null);
        }
    };

    const handleSaveChanges = async () => {

        try {
            const formData = new FormData();

            Object.keys(EditWarehouse).forEach((key) => {
                if (key === "capacity_summary") {
                    formData.append(key, JSON.stringify(EditWarehouse[key]));
                } else {
                    formData.append(key, EditWarehouse[key]);
                }
            });

            const response = await fetch(
                "https://ambronex.in/apis/WarehouseUpdate.php",
                {
                    method: "POST",
                    body: formData,
                }
            );

            const result = await response.json();

            if (result.status === "success") {
                setIsEditingUser(false);
                fetchWarehouselist();
                setOriginalWarehouse(EditWarehouse);
                Swal.fire({
                    icon: "success",
                    title: "Updated Successfully!",
                    text: "Warehouse details have been updated.",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "OK",
                });
            } else {
                console.log("Update failed");
                Swal.fire({
                    icon: "error",
                    title: "Update Failed",
                    text: result.message || "Something went wrong!",
                });
            }

        } catch (err) {
            console.error("Fetch Error:", err);
        }
    };

    const handleWarehouseChange = (field, value) => {
        setEditWarehouse({
            ...EditWarehouse,
            [field]: value,
        });
    };

    const WarehouseDD = dropdown?.Warehouse?.filter((item) => (item?.region === selectedRegion))

    const isChanged = JSON.stringify(EditWarehouse) !== JSON.stringify(originalWarehouse);

    const handleClose = () => {
        if (isChanged) {
            Swal.fire({
                icon: "warning",
                title: "Unsaved Changes",
                text: "There are unsaved changes. Are you sure you want to close?",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Close",
                cancelButtonText: "Cancel"
            }).then((result) => {
                if (result.isConfirmed) {
                    onClose();
                    setOriginalWarehouse(null);
                    setEditWarehouse(null);
                }
            });
        } else {
            onClose();
            setOriginalWarehouse(null);
            setEditWarehouse(null);
        }
    };

    return (
        <Drawer
            width={800}
            onClose={handleClose}
            open={open}
            // destroyOnClose
            title={
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontSize: "18px", fontWeight: 600 }}>
                        Modify Warehouse
                    </span>

                    <Button
                        type="primary"
                        size="small"
                        onClick={() => setShowOffcanvas(true)}
                    >
                        + New Warehouse
                    </Button>
                </div>
            }
        >
            {/* 🔹 Top Selection Section */}
            <Form layout="vertical" form={form} onFinish={onsubmit}>
                <Row gutter={16}>
                    <Col span={10}>
                        <Form.Item
                            label="Select Region"
                            name="region"
                            rules={[{ required: true, message: "Please select region" }]}
                        >
                            <Select placeholder="Choose region" value={selectedRegion}
                                onChange={(value) => setSelectedRegion(value)}
                            >
                                {dropdown?.Region?.map((i, item) => (
                                    <Option key={i} value={item?.region} >{item?.region}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label="Select Warehouse"
                            name="warehouse"
                            rules={[{ required: true, message: "Please select warehouse" }]}
                        >
                            <Select placeholder="Choose warehouse" value={selectedWarehouse}
                                onChange={(value) => setSelectedWarehouse(value)}
                            >
                                {WarehouseDD?.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={4} className="d-flex align-items-center">
                        <Button type="primary" htmlType="submit" block>
                            Submit
                        </Button>
                    </Col>
                </Row>
            </Form>

            {/* 🔹 Small Info Line */}
            <Text type="secondary">
                Select a region and warehouse to view complete details below.
            </Text>

            <Divider />

            {/* 🔹 Warehouse Details Section */}
            {EditWarehouse && (
                <div className="container-fluid mt-3">

                    {/* 🔹 Warehouse Details */}
                    {/* Header */}
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <div>
                            <h5 className="text-primary fw-bold">
                                <i className="bi bi-building me-2"></i>
                                Warehouse Details
                            </h5>
                            <small className="text-muted">
                                Update warehouse information below.
                            </small>
                        </div>

                        {/* Save Button */}
                        <div className="">
                            <button className="btn btn-sm btn-primary" onClick={handleSaveChanges} disabled={!isChanged}>
                                <i className="bi bi-save me-2"></i>
                                Save Changes
                            </button>
                        </div>

                    </div>

                    <div className="row g-3">

                        {/* Region */}
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-geo-alt me-2 text-secondary"></i>
                                Region
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse.region}
                                onChange={(e) =>
                                    handleWarehouseChange("region", e.target.value)
                                }
                            />
                        </div>

                        {/* Warehouse Name */}
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-building me-2 text-secondary"></i>
                                Warehouse Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse.wh_name}
                                onChange={(e) =>
                                    handleWarehouseChange("wh_name", e.target.value)
                                }
                            />
                        </div>

                        {/* Total Capacity */}
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-box me-2 text-secondary"></i>
                                Total Capacity
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse?.capacity_summary[0]?.total_capacity}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    setEditWarehouse(prev => ({
                                        ...prev,
                                        capacity_summary: [
                                            {
                                                ...prev.capacity_summary?.[0],
                                                total_capacity: value
                                            }
                                        ]
                                    }));
                                }}
                            />
                        </div>

                        {/* Occupied */}
                        <div className="col-md-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-archive me-2 text-secondary"></i>
                                Occupied
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse?.capacity_summary[0]?.occupancy}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    setEditWarehouse(prev => ({
                                        ...prev,
                                        capacity_summary: [
                                            {
                                                ...prev.capacity_summary?.[0],
                                                occupancy: value
                                            }
                                        ]
                                    }));
                                }}
                            />
                        </div>

                        {/* Address - Full Width */}
                        <div className="col-12">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-map me-2 text-secondary"></i>
                                Address
                            </label>
                            <textarea
                                className="form-control"
                                rows="3"
                                value={EditWarehouse.address}
                                onChange={(e) =>
                                    handleWarehouseChange("address", e.target.value)
                                }
                            />
                        </div>

                        {/* {district } */}
                        <div className="col-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-map me-2 text-secondary"></i>
                                District
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse.district}
                                onChange={(e) =>
                                    handleWarehouseChange("district", e.target.value)
                                }
                            />
                        </div>

                        {/* {pincode } */}
                        <div className="col-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-map me-2 text-secondary"></i>
                                Pin code
                            </label>
                            <input
                                maxLength={6}
                                type="text"
                                className="form-control"
                                value={EditWarehouse.pincode}
                                onChange={(e) =>
                                    handleWarehouseChange("pincode", e.target.value)
                                }
                            />
                        </div>

                        {/* {EditWarehouse.ofc_phn && */}
                        <div className="col-6">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-telephone-fill me-2 text-secondary"></i>
                                Office Phone Number
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={EditWarehouse.ofc_phn}
                                onChange={(e) =>
                                    handleWarehouseChange("ofc_phn", e.target.value)
                                }
                            />
                        </div>
                        {/* } */}

                        {/* map */}
                        <div className="col-12">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-geo-alt-fill me-2 text-secondary"></i>
                                Current Location
                            </label>
                            <iframe
                                src={EditWarehouse?.map}
                                width="100%"
                                height="400"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>

                            <div style={{ marginTop: '10px' }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <label className="form-label fw-semibold mb-0 d-flex align-items-center">
                                        <i className="bi bi-geo-alt-fill me-2 text-secondary"></i>
                                        Change Location
                                    </label>


                                    {/* Demo / Video Icon */}
                                    <div className="d-flex align-items-center">
                                        <button
                                            type="button"
                                            className="btn btn-sm text-primary p-0 me-1"
                                            onClick={() => setShowVideo(true)}
                                            title="Watch Demo"
                                        >
                                            <i className="bi bi-play-circle-fill" style={{ fontSize: '1.2rem' }}></i>
                                        </button>
                                        <span className="fs-6 text-secondary mb-0">Demo</span>
                                    </div>
                                </div>


                                <div className="d-flex align-items-center my-2">
                                    <Input
                                        placeholder="Paste new Google Maps embed URL here"
                                        value={inputUrl}
                                        onChange={(e) => setInputUrl(e.target.value)}
                                    />
                                    <Button
                                        type="primary"
                                        onClick={handleUpdateMap}
                                        style={{ marginLeft: '5px' }}
                                    >
                                        Update Map
                                    </Button>


                                </div>

                                {/* Bootstrap Modal for Video */}
                                <Modal
                                    show={showVideo}
                                    onHide={() => setShowVideo(false)}
                                    size="lg"
                                    centered
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title>Demo Video</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className="ratio ratio-16x9">
                                            <iframe
                                                src="https://ambronex.in/images/demovideo/map.mp4"
                                                title="Demo Video"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>

                        {/* images */}
                        {/* <div className="col-12">
                            <label className="form-label fw-semibold">
                                <i className="bi bi-images me-2 text-secondary"></i>
                                Images
                            </label>

                            <div className="d-flex flex-wrap gap-2">
                                {images.map((img, idx) => (
                                    <img
                                        key={idx}
                                        src={img}
                                        alt={`thumb-${idx}`}
                                        className="img-thumbnail"
                                        style={{ width: "100px", height: "100px", objectFit: "cover", cursor: "pointer" }}
                                        onClick={() => openModal(idx)}
                                    />
                                ))}

                                <button
                                    type="button"
                                    className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                    style={{ width: "100px", height: "100px" }}
                                    onClick={addImage}
                                >
                                    <i className="bi bi-plus-lg fs-3"></i>
                                </button>
                            </div>

                            {showModal && images.length > 0 && (
                                <div
                                    className="modal fade show"
                                    style={{ display: "block" }}
                                    tabIndex="-1"
                                    aria-labelledby="imageModalLabel"
                                    aria-hidden="true"
                                >
                                    <div className="modal-dialog modal-dialog-centered modal-lg">
                                        <div className="modal-content position-relative">
                                            <div className="modal-body p-0">
                                                <img
                                                    src={images[currentIndex]}
                                                    alt={`img-${currentIndex}`}
                                                    className="img-fluid w-100"
                                                />

                                                <button
                                                    type="button"
                                                    className="btn btn-danger position-absolute top-0 end-0 m-2"
                                                    onClick={removeImage}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-secondary position-absolute top-50 start-0 translate-middle-y"
                                                    onClick={prevImage}
                                                >
                                                    <i className="bi bi-chevron-left"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary position-absolute top-50 end-0 translate-middle-y"
                                                    onClick={nextImage}
                                                >
                                                    <i className="bi bi-chevron-right"></i>
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn-close position-absolute top-0 start-0 m-2"
                                                    onClick={() => setShowModal(false)}
                                                    aria-label="Close"
                                                ></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div> */}

                    </div>


                    <Divider />

                    {/* 🔹 User Details Card */}
                    <Col xs={24} md={10}>
                        <div className="card shadow border-0 rounded-4">

                            {/* Header */}
                            <div className="card-header bg-success text-white d-flex justify-content-between align-items-center">
                                <span>
                                    User Details
                                </span>

                                <i
                                    className={`bi ${isEditingUser ? "bi-x-square" : "bi-pencil-square"}`}
                                    style={{ cursor: "pointer", fontSize: "20px", transition: "0.2s" }}
                                    onClick={() => {

                                        setIsEditingUser(!isEditingUser);
                                    }}
                                ></i>
                            </div>

                            <div className="card-body">

                                <div className="row g-3">
                                    {[
                                        { label: "Name", field: "name", icon: "bi-person-fill", color: "text-primary" },
                                        { label: "Email", field: "email", icon: "bi-envelope-fill", color: "text-danger" },
                                        { label: "Phone", field: "phone_no", icon: "bi-telephone-fill", color: "text-success" }
                                    ].map((item) => (
                                        <div key={item.field} className={isEditingUser ? "col-12" : "col-12 m-0"}>

                                            <label className="form-label small m-0 fw-semibold">
                                                <i className={`bi ${item.icon} me-2 ${item.color}`}></i>
                                                {item.label}:
                                            </label>

                                            {isEditingUser ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={EditWarehouse[item.field] || ""}
                                                    onChange={(e) =>
                                                        handleWarehouseChange(item.field, e.target.value)
                                                    }
                                                />
                                            ) : (
                                                <span className="ms-2 text-muted">
                                                    {EditWarehouse[item.field] || ""}
                                                </span>
                                            )}
                                        </div>
                                    ))}

                                    <div className={isEditingUser ? "col-12" : "col-12 m-0"}>
                                        <label className="form-label small m-0 fw-semibold">
                                            <i className="bi bi-person-badge-fill me-2 text-warning"></i>
                                            Role:
                                        </label>

                                        {isEditingUser ? (
                                            <Select
                                                value={EditWarehouse.role}
                                                onChange={(value) =>
                                                    handleWarehouseChange("role", value)
                                                }
                                                style={{ width: "100%" }}
                                            >
                                                <Option value="Manager">Warehouse Manager</Option>
                                            </Select>
                                        ) : (
                                            <span className="ms-2 text-muted">
                                                {EditWarehouse?.role || ""}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>

                </div>
            )}

            <NewWarehouse
                show={showOffcanvas}
                handleCanvaClose={() => setShowOffcanvas(false)}
                fetchWarehouselist={fetchWarehouselist}
            />

        </Drawer >
    );
};

export default ModifyWarehouseDrawer;